export const CountryCode = {
  AU: 'AU',
  NZ: 'NZ',
}

export const CountryName = {
  [CountryCode.AU]: 'Australia',
  [CountryCode.NZ]: 'New Zealand',
}
